import {CityInterface} from "./CityInterface";
/*
 * Управление городом
 */
export class City {

    private code: string;
    private name: string;
    private profileElements: HTMLCollectionOf<HTMLElement>;

    setCity(city: CityInterface) {
        this.code = city.code;
        this.name = city.name;
    }

    constructor(profileElements: any) {
        this.profileElements = profileElements;
    }

    render() {
        if (!this.name) {
            return;
        }
        for (let i = 0; i < this.profileElements.length; i++) {
            this.profileElements[i].innerHTML = this.name;
        }
    }

}
